import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'Profile';
const ENDPOINT = `/profiles/`;

@Injectable({
    providedIn: 'root'
})
export class ProfileService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
